import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import { useDevice } from '@atc/react-device';
import { jsx as _jsx } from "react/jsx-runtime";
const orientationMode = ['portrait', 'landscape'];
const triggerEventClick = ['click'];
const triggerEventAll = ['hover', 'focus', 'click'];

/**
 * HOC withOverlayTrigger calculate position for Popover base on screen size and orientation mode
 * Using Example: withOverlayTrigger({ defaultPosition: 'bottom', top: ['md'], right: ['md', 'landscape']})(Component)
 *
 * @param {Object} config
 *  - Ex: { defaultPosition: 'bottom', top: ['md'], right: ['md', 'landscape']}
 *  - key defaultPosition: default popover position
 *  - position: condition
 *     + position = top, bottom, left, right
 *     + condition: array orientation mode and screen max size apply (Ex: apply screen xs, sm => ['sm'])
 *     + Ex: right: ['md', 'landscape']
 */
export default config => Component => props => {
  const {
    defaultPosition,
    ...positions
  } = config;
  const device = useDevice();
  const [position, setPosition] = useState(defaultPosition);
  const [triggerEvent, setTriggerEvent] = useState(triggerEventClick);
  useEffect(() => {
    const inScreenSize = screenSize => !_get(device, `greaterThan.${screenSize}`, false);
    const inOrientationMode = mode => _get(device, 'orientation', '') === mode;
    const checkPositionActive = conditions => conditions.reduce((active, condition) => {
      const validCondition = orientationMode.includes(condition) ? inOrientationMode(condition) : inScreenSize(condition);
      return active && validCondition;
    }, true);
    let activePos = defaultPosition;
    Object.keys(positions).forEach(pos => {
      const condition = positions[pos];
      if (checkPositionActive(condition)) {
        activePos = pos;
      }
    });
    setPosition(activePos);

    // config trigger event
    const isLessThanMedium = _get(device, 'lessThan.md', false);
    const trigger = isLessThanMedium ? triggerEventClick : triggerEventAll;
    if (trigger !== triggerEvent) {
      setTriggerEvent(trigger);
    }
  }, [defaultPosition, device, position, positions, triggerEvent]);
  return /*#__PURE__*/_jsx(Component, {
    ...props,
    popoverPosition: position,
    popoverTriggerEvent: triggerEvent
  });
};